import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_PRODUCT_AANVRAGEN: MijnRoute = {
    path: 'product-aanvragen',
    navigationEvent: 'toProductAanvragen',
    regex: /^\/zelf-regelen\/product-aanvragen$/,
    webcomponent: 'mijn-product-aanvragen-webcomponent'
};
